<template>

<div id="schema_form">
  <v-container>
    <v-form ref="form" v-model="valid" v-if="schema">
      <v-jsf v-model="vModel" :schema="schema" :options="options" />
    </v-form>
    <v-layout row class="mt-2">
      <v-spacer></v-spacer>
      <v-btn color="primary" @click="save()">Save</v-btn>
      <v-btn color="secondary" @click="cancel()">Cancel</v-btn>
    </v-layout>
  </v-container>
</div>
</template>
<style scoped>
</style>
<script>
import axios from '../lib/axios'
//import _ from 'lodash'
const log = console.log;

const options =  {}

//Vue.component('VJsf', VJsf.default)

export default {
  data() {
    return {
        vModel: {...this.model},
        options,
        schema: null,
        valid: null
    }
  },
  props: {
      model: Object,
      item: String
  },
  created() {
      this.schemaUpdate()
  },
  methods: {
    schemaUpdate () {
            var self = this

            axios.get('/static/schema/'+self.item+'.json')
            .then(function (response) {
                //var d = response.data;
//                if (d.status!="success") {
//                    throw d;
//                }
                self.schema = response.data
            })
            .catch((err) => {
                log('ERROR','SchemaForm:schemaUpdate', err.message)
                /*
                if (err.message.includes('504')) {
                    _.delay(this.refresh,300)
                } else {
                    this.message = {msg:err.message,icon:'error',header:'Error'}
                }
                */
self.$store.commit('showMessage', { content: err.message||"ERROR", color: 'error' })
            });
        },
        save() {
            var data = {...this.vModel}
//            data = {...this.model, ...this.vModel}
            this.$emit('save',data)
        },
        cancel() {
            this.$emit('cancel')
        }
  }
}

</script>
      
